import { AttendeeHelper } from '..';

export const useAttendee = () => {
	let attendeeHelper = new AttendeeHelper();
	return {
		attendeeHelper,
		activeAttendee: attendeeHelper.active()
	};
};
